import gql from 'graphql-tag'
import { GET_LIST, GET_MANY_REFERENCE, GET_ONE } from 'react-admin'

const buildFields = gql`
  {
    id
    relation
    relation_id
    operation
    action_tstamp_tx
    user {
      id
      # auth.users is camelCase; aliased to the names the views read.
      display_name: displayName
      role: defaultRole
    }
    history {
      relation
      relation_id
      operation
      change
    }
  }
`

const extendFields = gql`
  {
    history_transaction(limit: 1, order_by: { action_tstamp_tx: desc }) {
      id
      operation
      action_tstamp_tx
      user {
        id
        # auth.users is camelCase; aliased to the names the views read.
        display_name: displayName
        role: defaultRole
      }
    }
  }
`

export const HistoryTransactionQueries = {
  [GET_LIST]: { buildFields },
  [GET_MANY_REFERENCE]: { buildFields },
  extendFields: {
    // ignroe this extension on the following resources
    ignore: ['history', 'history_transactions'],
    // add to all other queries
    [GET_ONE]: extendFields,
    [GET_LIST]: extendFields,
  },
}
export default HistoryTransactionQueries
